<template>
  <div class="folder-header position-relative" v-on:click="$emit('open-container')">
    <div class="col-12 col-lg-4 p-0 position-initial">
        <span class="folder-header__icon">
          <img src="../../assets/images/folder-open.svg" alt="" v-if="isOpen"/>
          <img src="../../assets/images/folder.svg" alt="" v-if="!isOpen"/>
        </span>
      <span class="folder-header__title">{{ name }}</span>
      <span class="folder-header__arrow align-right folder-header__arrow--right d-md-none">
          <img src="../../assets/images/arrow-right.svg" alt="Right"/>
        </span>
    </div>
    <div class="col-6 col-lg-4 pl-0 folder-header__text-container">
      <span class="folder-header__text">
        <span v-if="totalFolders > 0">
          {{ totalFolders }} Subfolder<span v-show="totalFolders !== 1">s</span>
        </span>
        <span v-if="totalFolders === 0 && totalFiles > 0">
          {{ totalFiles }} Document<span v-show="totalFiles !== 1">s</span>
        </span>
      </span>
    </div>
    <div class="col-6 col-lg-4 position-initial">
      <span class="folder-header__text folder-header__text--date"><span class="d-none d-lg-inline d-xl-none">Latest&nbsp;</span>Update<span class="d-inline d-lg-none d-xl-inline">d</span> {{ lastUpdated | moment("MMM DD, YYYY") }}</span>
      <span class="folder-header__arrow align-right d-none d-md-inline-block"
            v-bind:class="isOpen ? 'folder-header__arrow--up' : 'folder-header__arrow--down'">
          <img src="../../assets/images/arrow-down.svg" alt=""/>
        </span>
    </div>
  </div>
</template>
<script>
  export default {
    name: "UXFolderHeader",
    props: {
      name: String,
      totalFolders: Number,
      totalFiles: Number,
      lastUpdated: String,
      isOpen: Boolean,
      filesType: String
    }
  };
</script>
